import BillingPeriodStatus from "./BillingPeriodStatus";

class BillingPeriod {
    public id: string;
    public description: string;
    public startDate: number;
    public endDate: number;
    public status: BillingPeriodStatus;
    public createdAt: number;

    constructor(id: string, description: string, startDate: number, endDate: number, status: BillingPeriodStatus, createdAt: number) {
        this.id = id;
        this.description = description;
        this.startDate = startDate;
        this.endDate = endDate;
        this.status = status;
        this.createdAt = createdAt;
    }

}

export default BillingPeriod;